import { render } from "./TabSet.vue?vue&type=template&id=522b12a3&scoped=true"
import script from "./TabSet.vue?vue&type=script&lang=js"
export * from "./TabSet.vue?vue&type=script&lang=js"

import "./TabSet.vue?vue&type=style&index=0&id=522b12a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-522b12a3"

export default script